module.exports = __webpack_public_path__ + "img/vo-440.c14ed2e9.jpg";